var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricePsq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.66,6.34,18.72,7.4,18,8.11,17,7.05,15,9l1.06,1.06-.71.71L14.3,9.7l-1.94,1.94,1.06,1.06-.71.71-1.06-1.06-2,2,1.06,1.06-.71.71L9,15,7.05,17,8.11,18l-.71.71L6.34,17.66,4,20H18a2,2,0,0,0,2-2V4ZM17,17H11.24L17,11.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,2H13V15H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39,7.9c-1.23-.32-1.62-.65-1.62-1.16s.54-1,1.46-1,1.32.46,1.35,1.14h1.2A2.17,2.17,0,0,0,7,4.81V3.63H5.42V4.8a2.11,2.11,0,0,0-1.9,2C3.52,8,4.56,8.62,6.07,9c1.35.32,1.62.8,1.62,1.3s-.26,1-1.46,1-1.56-.5-1.62-1.13H3.42a2.28,2.28,0,0,0,2,2.07v1.18H7V12.21c1.06-.2,1.9-.81,1.9-1.92C8.94,8.75,7.62,8.22,6.39,7.9Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricePsq);
export default __webpack_public_path__ + "static/media/price-psq.8d5d80f9b0d70e550852bdd351e4852a.svg";
export { ForwardRef as ReactComponent };